import { useContext } from 'react';
import { Maybe } from '@csp/csp-common-model';
import { AnalyticsContext, AnalyticsAPI } from './AnalyticsContext';

export const useMaybeAnalyticsContext = (): Maybe<AnalyticsAPI> => useContext(AnalyticsContext);
